import { render } from "./whats-on-calendar.vue?vue&type=template&id=e4c7e9d4"
import script from "./whats-on-calendar.vue?vue&type=script&lang=js"
export * from "./whats-on-calendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__